(function($2) {
     var document2 = $2(document2);
    document2.ready(function() {
        Custom.init(); homepage(); waypoints();
    });
     var Custom = {
        init: function() {
           this.feturedSlider();this.productSlider(); this.partner_brand_slider(); this.TextSlider();
        },
       <!-- Initialize Swiper -->
       feturedSlider : function () {
          var featured = $2(".data-desktop-slider");
          featured.each(function() {
          var self = $2(this);
          var show_product = self.find(".product-grid").attr("data-show-product");
           //console.log("per page", show_product);  
          var mySwiper = new Swiper(".data-desktop-slider", {
                loop:true,
                pagination: {
                  el: ".collection .swiper-pagination",
                  clickable: true
                },
                navigation: {
                  nextEl: ".collection .swiper-button-next",
                  prevEl: ".collection .swiper-button-prev"
                },
                breakpoints: {
                  320: {
                    loop:true,
                    centeredSlides: true,
                    freeMode: true,
                    slidesPerView:1.14,
                    spaceBetween:15,
                  },
                  750: {
                    centeredSlides: false,
                    freeMode: false,
                    slidesPerView: show_product,
                    centeredSlides: false,
                    slidesPerView:'auto',
                    loop: false,
                  }
                }
             });
          });
       },
        productSlider : function () {  
        //** Thumbnail Slider For DD //
        const sliderThumbsNail = new Swiper('.slider-thumbs .swiper-container', {
        	slidesPerView: 4.5,
        	spaceBetween:15,
        	freeMode: true,
        	loop:false,
        	grabCursor: true,
            autoHeight: false,
            loading:"lazy",
            height:547.5,
        	breakpoints: {
        		0: {
        			direction: 'horizontal',
                    slidesPerView: 4.2,
                    autoHeight: false,
                    height:"auto",
        		},
        		989: {
        			direction: 'vertical',
                 
        		}
        	}
        });
        
        const sliderImages = new Swiper('.slider-product-image .swiper-container', {
        	slidesPerView: 1,
        	spaceBetween: 0,
        	mousewheel: false,
        	grabCursor: true,
            loading:"lazy",
          pagination: {
                el: ".slider-product-image .swiper-pagination",
                type: "fraction",
               renderFraction: function (currentClass, totalClass) {
              return '<span class="' + currentClass + '"></span>' +
                     '<span class="text_count_slider"> of</span> ' +
                     '<span class="' + totalClass + '"></span>';
               }
                },
             navigation: {
               nextEl: ".slider-product-image .slider-button.slider-button--next", 
              prevEl: ".slider-product-image .slider-button.slider-button--prev" 
            },
        	thumbs: {
        		swiper: sliderThumbsNail
        	},
        	breakpoints: {
        		0: {
        			direction: 'horizontal',
        			slidesPerView: 1.12,
        			spaceBetween:15,
                    mousewheel: false,
        		},
        		989: {
        			direction: 'vertical',
                   
        		}
        	}
        });
        //** Thumbnail Slider For DD End: //

          
          var swiperSlide = document.getElementsByClassName('swiper-slide')
    for(var index = 0; index< swiperSlide.length; index++){
    swiperSlide[index].addEventListener('mouseover',function(e){
      //console.log('1');
        sliderImages.zoom.in();
    })
    
    swiperSlide[index].addEventListener('mouseout',function(e){
      //console.log('2');
        sliderImages.zoom.out();
    })
    }
       },

       partner_brand_slider : function () {
        const partnerbrandslider  = $2(".section-brand-logo");
         partnerbrandslider.each(function() {
          var self = $2(this);
          var enableSlider = self.find(".container-slider").attr("data-slider"); 
          var show_per_row_items = self.find(".container-slider").attr("data-show"); 

           if(enableSlider) {
             
              console.log("brand", show_per_row_items);

              var swiper = new Swiper(".enable-slider-container", {
                  slidesPerView: show_per_row_items,
                  loop:false,
                pagination: {
                  el: ".swiper-controllers-partner-brand .swiper-pagination",
                  clickable: true,
                },
                 navigation: {
                  nextEl: ".swiper-controllers-partner-brand .swiper-button-next",
                  prevEl: ".swiper-controllers-partner-brand .swiper-button-prev"
                },
                breakpoints: {
                  320: {
                    slidesPerView: 1,
                    loop: false,
                    spaceBetween:0,
                    centeredSlides: true,
                  },
                  768: {
                       spaceBetween:0,
                    },
                  1024: {
                      spaceBetween:0,
                    }
                }
              });
           }
         });
       },
        TextSlider : function (){
          const sliderText = new Swiper('.partnerTextSlider', {
              slidesPerView: 1,
              loop: true,
              effect: "fade",
              fadeEffect: {
                crossFade: true
              },
              grabCursor: true,
              autoHeight: true,
              navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
              },
              pagination: {
                el: ".swiper-pagination",
                clickable: true,
              }
              });
           }
  
     }

 

 $('variant-radios .product-form__input input[type="radio"]').each( function (){
    $(this).click(function (){
        var CurrentRadioValue = $(this).val();
        var legend = $('.product-form__input').find('.change_variant_value').html(CurrentRadioValue);
    });
})
})(jQuery)


 $(".collection .card__information .card__heading a").html(function(){
   var text= $(this).text().trim().split(" ");
   var first = text.shift();
   return (text.length > 0 ? "<span class='hiddenText'>"+ first + "</span> " : first) + text.join(" ");
 });

 // Chocolat(document.querySelectorAll('.product__media-item .product__media .lightboxxx'), {
 //        imageSize: 'contain',
 //    })

function waitForEl(selector, callback) {
  if (jQuery(selector).length) {
      callback();
  } else {
      setTimeout(function () {
          waitForEl(selector, callback);
      }, 100);
  }
}
// Chocolat(document.querySelectorAll(".lightboxxx"), {
//   container: document.querySelector(".chocolat-lightboxx"),
//   loop: true,
//   imageSize: "contain",
//   //imageSize: 'native',

//   allowZoom: false,
// });
// function custom_zoom() {
//       let i = 0;

//       let img_wrapper = $(".chocolat-image-wrapper");

//       let alto_original = img_wrapper.height();
//       let ancho_original = img_wrapper.width();

//       $(".chocolat-img").click(function () {
//           i++;

//           // $(this).draggable({
//           //     scroll: false,
//           //     refreshPositions: true,
//           //     revert: true,
//           // });

//           $(this).addClass("position-relative");

//           if (i == 1) {
//               img_wrapper.height(alto_original * 1.7);
//               img_wrapper.width(ancho_original * 1.7);
//           } else if (i == 2) {
//               img_wrapper.height(alto_original * 2.5);
//               img_wrapper.width(ancho_original * 2.5);
//           } else if (i == 3) {
//               img_wrapper.height(alto_original * 3);
//               img_wrapper.width(ancho_original * 3);
//           } else {
//               i = 0;

//               $(this).parent().height(alto_original);
//               $(this).parent().width(ancho_original);
//           }

//           /*$(this).parent().css({
//               transition: " all .1s",
//           });*/

//           //let val = 3;
//           /* $(this).css({
//               '-webkit-transform': 'scale(' + val + ')',
//               '-moz-transform': 'scale(' + val + ')',
//               '-ms-transform': 'scale(' + val + ')',
//               '-o-transform': 'scale(' + val + ')',
//               'transform': 'scale(' + val + ')',
//               'transition':' all .2s',
//           }); */
//       });
//   }

// $(".product__media-item .product__media .lightboxxx").click(function (e) {
//      e.preventDefault();
//       waitForEl(".chocolat-image-canvas.chocolat-visible", function () {
//           custom_zoom();
//       });

//       $(".chocolat-right, .chocolat-left").click(function () {
//           // Esperamos a que se quite la clase chocolat-visible, para esperar a que se vuelva a poner una vez cargada la imagen nueva
//           setTimeout(function () {
//               waitForEl(".chocolat-image-canvas.chocolat-visible", function () {
//                   custom_zoom();
//               });
//           }, 200);
//       });
//       $(".chocolat-close").click(function (){
//         $('body').removeClass('chocolat-open');
//         $('body').removeClass('undefined')
//       })
// });

// jQuery(document).ready( function(){
//   homepage();
//   waypoints();
// });

function homepage(){
$windowHeight = jQuery(window).height();
jQuery(window).scroll(function(){
     var nowScrollTop = jQuery(this).scrollTop() + $windowHeight - $windowHeight*0.3;
     jQuery(".scrollAnimatedItem").each(function(){
		$thisTop = jQuery(this).offset().top ;
        jQuery(this).attr("data-top", $thisTop);
        if( nowScrollTop >= $thisTop){
            jQuery(this).addClass("inview");
        }
        else{
            jQuery(this).removeClass("inview");
        }
     });
});
}
function waypoints(){
jQuery('.scrollAnimatedItem').each(function() {
        jQuery(this).waypoint(function(direction) {
        	if (direction === "down") {
                jQuery(this.element).addClass('animated fadeInUp inview');
                  console.log('hieght');
        	}
        	else{ 
        		jQuery(this.element).removeClass('animated fadeInUp inview');
        	}
        },{ offset: '90%'});
    });	
}




// set cookie when click announcement cross btn 

$(document).ready( function () {
    $('.announcement-bar-close').click( function () {
       $('#Moving_notice').fadeOut("slow");
       $.cookie('headerTopAnnouncement', 'closed', {
                expires: 1,
                path: '/'
            });
    });
    if ($.cookie('headerTopAnnouncement') == 'closed') {
        $('#Moving_notice').css("display", "none");
    };

});


$('.pillcontainerlnd-imgtxt1 .image-with-text__text p, .mobile-scroll-down').click( function (){
    const destination = $(".pillcontainerlnd-richtxt1");
    $('html,body').animate({
      scrollTop: destination.offset().top - 100
    },'slow');
});

  function checkArrayLengthTwo() {
    var MyArray = document.querySelectorAll('.gPreorderSellingPlanWrapper');
    var MyArrayHtml = MyArray[0];
    var PillMsg = document.querySelectorAll('.gPreorderTopMessage');
    if(MyArray.length === 1 ){
       $(PillMsg).html('');
      $(MyArrayHtml).find('.gPreorderSellingPlanNameWrapper h3 p').html('Payment option:');
      var PriceItem = $('.price__container .price-item').html();
      var Message = 'FULL ('+PriceItem+')';
      var Paymentoption = 'PAYMENT OPTION: ';
      var currentPayment = Paymentoption + '' + Message + '';
      $(MyArrayHtml).find('.gPreorderSellingPlanNameWrapper h3 .gPreorderSellingPlanName').html(currentPayment);
      clearInterval(intervalIDTwo);
    }
  }
var intervalIDTwo = setInterval(checkArrayLengthTwo, 1000); // Runs every 1 second (adjust as needed)
var flagGpreorder = true;


 $(document).on('click', '.gPreorderSellingPlanValue', function(){
       if(jQuery(this).find('.gPreorderPartialPaymentPrice').length > 0){
           const checkedInputclick = $('.gPreorderSellingPlanValue').find('.gPreorderPartialPaymentPrice').text();
        const PriceItemWithoutSpliting = jQuery('.product__info-container .price__container .price-item--regular').text();
          var splitPrice = PriceItemWithoutSpliting.split(/(\d+)/);
        var splitParitalPayment = checkedInputclick.split(/(\d+)/);
           var pendingPrice = splitPrice[1] - splitParitalPayment[1];

         setTimeout(function() {
           jQuery('.gPreorderSellingPlanName').text('PAYMENT OPTION: PARTIAL ('+checkedInputclick+' NOW & REMAINING $'+pendingPrice + ' WHEN FULFILLED)');
         },100)
       }else{
         const PriceItemWithoutSplit = jQuery('.product__info-container .price__container .price-item--regular').text();
         setTimeout(function() {
           jQuery('.gPreorderSellingPlanName').text('PAYMENT OPTION: FULL ('+PriceItemWithoutSplit +')');
         },100)
       }
  });

// $(".product-form__buttons").on("DOMSubtreeModified", ".gPreorderSellingPlanWrapper", function () {
//     $(this).find('.gPreorderSellingPlanOptions .gPreorderSellingPlanValue label').each(function () {
//         $(this).on('click', function () {
//             // Wrap the asynchronous operation in a Promise
//             var promise = new Promise((resolve, reject) => {
//                 setTimeout(() => {
//                     // Your asynchronous code here
//                     var checkedInputclick = $(this).find('.gPreorderSellingPlanOptionName').text();
//                     //var ParitalPaymentWithoutSplit = $(this).find('.gPreorderPartialPaymentPrice').html();
//                     var PriceItemWithoutSplit = $('.price__container .price-item').html();
//                     var ParitalPayment = $(this).find('.gPreorderPartialPaymentPrice').html();
//                     var splitPrice = PriceItemWithoutSplit.split(/(\d+)/);
//                     var splitParitalPayment='';
//                     if(ParitalPayment){
//                      splitParitalPayment = ParitalPayment.split(/(\d+)/);
//                     }
//                     var pendingPrice = splitPrice[1] - splitParitalPayment[1];
//                     var PriceItem = $('.price__container .price-item').html();
//                     var Paymentoption = 'PAYMENT OPTION: ';
//                     var Message = '';
//                     if (checkedInputclick == 'Partial Payment') {
//                         Message = 'PARTIAL ('+ParitalPayment+' NOW & '+splitPrice[0]+ pendingPrice+' WHEN SHIPPED)';
//                     } else if (checkedInputclick == 'Full Payment') {
//                         Message = 'FULL ('+PriceItem+')';
//                     }
//                     var currentPayment = Paymentoption + '' + Message + '';

//                     $('.gPreorderSellingPlanNameWrapper h3 .gPreorderSellingPlanName').html(currentPayment);
//                     // Resolve the Promise
//                     resolve();
//                 }, 600);
//             });

//             // Use the Promise
//             promise.then(() => {
//                 // Handle promise resolution
//                 //console.log('Promise resolved');
//             }).catch((error) => {
//                 // Handle promise rejection
//                 console.error('Error:', error);
//             });
//         });
//     });
// });

//  function checkArrayLengthTwo() {
//     var MyArray = document.querySelectorAll('.gPreorderPartialPaymentWrapper');
//     var MyArrayHtml = MyArray[0];
//     var PillMsg = document.querySelectorAll('.gPreorderTopMessage');
//     if(MyArray.length === 1 ){
//        $(PillMsg).html('');
//       $(MyArrayHtml).find('.gPreorderPartialPaymentLabel:first').html('Payment option:');
//       var PriceItem = $('.price__container .price-item').html();
//       var Message = 'FULL('+PriceItem+')';
//       var Paymentoption = 'PAYMENT OPTION: ';
//       var currentPayment = Paymentoption + '' + Message + '';
//       $(MyArrayHtml).find('.gPreorderPartialPaymentLabel:first').html(currentPayment);
//       clearInterval(intervalIDTwo);
//     }
//   }
// var intervalIDTwo = setInterval(checkArrayLengthTwo, 1000); // Runs every 1 second (adjust as needed)
// var flagGpreorder = true;

// $(".product-form__buttons").on("DOMSubtreeModified", ".gPreorderPartialPaymentWrapper", function () {
//     $(this).find('.gPreorderPartialPaymentChoices li label').each(function () {
//         $(this).on('click', function () {
//             // Wrap the asynchronous operation in a Promise
//             var promise = new Promise((resolve, reject) => {
//                 setTimeout(() => {
//                     // Your asynchronous code here
//                     var checkedInputclick = $(this).find('span.gPreorderPartialPaymentLabel').text();
//                     var newcheckInput = checkedInputclick.split(/(\d+)/);
//                     //console.log('partial', newcheckInput);
//                     //var ParitalPaymentWithoutSplit = $(this).find('.gPreorderPartialPaymentPrice').html();
//                     var PriceItemWithoutSplit = $('.price__container .price-item').html();
//                     var ParitalPayment = $(this).find('.gPreorderPartialPaymentLabel span').html();
//                     var splitPrice = PriceItemWithoutSplit.split(/(\d+)/);
//                     var splitParitalPayment='';
//                     if(ParitalPayment){
//                      splitParitalPayment = ParitalPayment.split(/(\d+)/);
//                     }
//                     var pendingPrice = splitPrice[1] - splitParitalPayment[1];
//                     var PriceItem = $('.price__container .price-item').html();
//                     var Paymentoption = 'PAYMENT OPTION: ';
//                     var Message = '';
//                     if (newcheckInput[0] == 'Partial Payment $') {
//                         Message = 'PARTIAL ('+ParitalPayment+' NOW & '+splitPrice[0]+ pendingPrice+' WHEN SHIPPED)';
//                     } else if (newcheckInput[0] == 'Full Payment') {
//                         Message = 'FULL('+PriceItem+')';
//                     }
//                     var currentPayment = Paymentoption + '' + Message + '';

//                     $('.gPreorderPartialPaymentLabel:first').html(currentPayment);
//                     // Resolve the Promise
//                     resolve();
//                 }, 300);
//             });

//             // Use the Promise
//             promise.then(() => {
//                 // Handle promise resolution
//                 //console.log('Promise resolved');
//             }).catch((error) => {
//                 // Handle promise rejection
//                 console.error('Error:', error);
//             });
//         });
//     });
// });


// newsletter popup form js

jQuery(document).ready( function () {
  jQuery('.announcement-bar__message strong').on('click', function (e) {
      e.preventDefault();
      NewsletterFormPopupModal();
  });
  jQuery('.closeModalNewsletterThanks, .closeModalNewsletter').on('click', function (e) {
    e.preventDefault();
    NewsletterFormPopupModalClose();
  });
  successNewsletterForm();

});
function NewsletterFormPopupModal() {
    var NewsletterModalOpener = document.querySelector('.custom-newsletter-modal'),
    modalOpenerChild = document.querySelector('.container-popup-modal');

    NewsletterModalOpener.classList.remove('closed-opener-modal');
    modalOpenerChild.classList.remove('closed-opener-modal');
    $(modalOpenerChild).fadeIn(3000);

   if($('.container-popup-modal .success-form-modal').hasClass('newsletter-form__message--success')){
       jQuery(".custom-newsletter-modal").removeClass('closed-opener-modal');
       jQuery(".container-popup-modal").removeClass('closed-opener-modal'); 
       jQuery('.top-content-area').css('display','none');
       jQuery('.newletterForm-submit').css('display','none');
       jQuery('.no-thanks-btn').hide();
  }
   if($('.container-popup-modal .form-signup-success').hasClass('form-login-user-form__message--success')){
       jQuery(".custom-newsletter-modal").removeClass('closed-opener-modal');
       jQuery(".container-popup-modal").removeClass('closed-opener-modal'); 
       jQuery('.top-content-area').css('display','none');
       jQuery('.signupForm-submit').css('display','none');
       jQuery('.no-thanks-btn').hide();
  }
 }
function NewsletterFormPopupModalClose() {
    jQuery(".custom-newsletter-modal").addClass('closed-opener-modal');
    jQuery(".container-popup-modal").addClass('closed-opener-modal');
}

function successNewsletterForm() {
   //check form submit;
  if($('.container-popup-modal .success-form-modal').hasClass('newsletter-form__message--success')){
       jQuery(".custom-newsletter-modal").removeClass('closed-opener-modal');
       jQuery(".container-popup-modal").removeClass('closed-opener-modal'); 
       jQuery('.top-content-area').css('display','none');
       jQuery('.newletterForm-submit').css('display','none');
       jQuery('.no-thanks-btn').hide();
  }
}

// end newsletter popup functionality 



/**freee product**/

(function() {
  
           async function addToCartClick(event) {
             try {
            let response = await fetch(window.Shopify.routes.root + 'cart.js');
            let data = await response.json();
            const productIdToCheck = 9704804516155;
            const isProtected = data.items.some(item => item.product_id === productIdToCheck);
            console.log(isProtected, 'protection status');

            if (!isProtected) {
                setTimeout(afterClickFunction, 1500);
               console.log('Product is not available',data);
            } else {
                console.log('Product is already available');
               setTimeout(removeProduct, 1000);
            }
        } catch (error) {
            console.error('Error fetching cart:', error);
        }
    }

    async function afterClickFunction() {
         var itemId = item.ProductID;
         const validItemIds = [8096980894011];
          if(validItemIds.includes(itemId)){
            console.log('yes');
          }else{
            console.log('no');
          }
                    if (itemId === 8096980894011) {
            const variantId = 49273986384187;
            const data = {
                items: [{
                    id: variantId,
                }]
            };
            try {
                let response = await fetch('/cart/add.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(data)
                });
                console.log('Product added to cart');
                setTimeout(onCartUpdate, 1000);
            } catch (error) {
                console.error('Error adding product to cart:', error);
            }
        }else{
                      console.log('not found');
        }
    }
  
        function delay(ms) {
                    return new Promise(resolve => setTimeout(resolve, ms));
                }


         async function onCartUpdate() {
        try {
            let response = await fetch(window.Shopify.routes.root + "?section=cart-drawer");
            let responseText = await response.text();
            const cart_open = document.querySelector('#CartDrawer');
            const countBubble = document.querySelector('.cart-count-bubble');
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const bubble = html.querySelector('.cart-count-bubble');
            const cart_drawer = html.querySelector('.cart-drawer');

            cart_open.innerHTML = cart_drawer.innerHTML;
            countBubble.innerHTML = bubble.innerHTML;
        } catch (error) {
            console.error('Error updating cart:', error);
        }
        setTimeout(removeProduct, 1000);
    }

    async function removeProduct() {
        const removeButtons = document.querySelectorAll('cart-remove-button');
     // console.log('cart-remove-button',removeButtons);
        removeButtons.forEach((removeButton) => {
            removeButton.addEventListener('click', async function() {
                await handleRemoveProduct();
            });
        });
    }

   function handleRemoveProduct() {
            return fetch(window.Shopify.routes.root + 'cart.js')
                .then(response => {
                    if (!response.ok) {
                        console.error("Failed to fetch cart. Status:", response.status);
                        return Promise.reject("Request failed");
                    }
                    return response.json();
                })
                .then(data => {
                    const productIdToCheck = 9704804516155;

                    const shouldRemove = data.items.some(item => item.product_id === productIdToCheck);

                    if (shouldRemove) {
                        console.log("Product is available for removal");

                        // Reduced timeout to 100ms
                        setTimeout(() => {
                            if (typeof removeProductCart === "function") {
                                removeProductCart();
                            }
                        }, 100);

                    } else {
                        console.log("Product is not available");
                    }
                })
                .catch(error => {
                    console.error("Error fetching cart for removal:", error);
                });
        }


    async function removeProductCart() {
        try {
            let response = await fetch('/cart.js');
            let cart = await response.json();
            //const productIdToMonitor = 8731206975803;
            const associatedProductId = 8096980894011;
            //const isProductInCart = cart.items.some(item => item.product_id === productIdToMonitor);
            const isAssociatedInCart = cart.items.some(item => item.product_id === associatedProductId);

            if ( !isAssociatedInCart) {
                await removeProductFromCart(49273986384187);
            } else {
                console.log('Product is available in cart');
              setTimeout(removeProductCart,600);
            }
        } catch (error) {
            console.error('Error handling product cart:', error);
        }
    }

   function removeProductFromCart(productId) {
          return fetch(`${window.Shopify.routes.root}cart/update.js`, {
              method: "POST",
              headers: {
                  "Content-Type": "application/json",
                  "Accept": "application/json"
              },
              body: JSON.stringify({
                  updates: {
                      [productId]: 0
                  }
              })
          })
          .then(response => {
              if (!response.ok) {
                  console.error("Failed to remove product. Status:", response.status);
                  return Promise.reject("Request failed");
              }
              return response.json();
          })
          .then(cartData => {
              console.log("Product removed successfully:", cartData);

              setTimeout(() => {
                  if (typeof onCartUpdate === "function") onCartUpdate();
              }, 500);

              setTimeout(() => {
                  if (typeof checkCart === "function") checkCart();
              }, 700);
          })
          .catch(error => {
              console.error("Error removing product from cart:", error);
          });
      }


    async function checkCart() {
        try {
            let response = await fetch('/cart.js');
            let cart = await response.json();
            if (cart.item_count === 0) {
                setTimeout(emptyCart, 500);
            } else {
                console.log('Cart has items');
            }
        } catch (error) {
            console.error('Error checking cart:', error);
        }
    }

    function emptyCart() {
        const cart_empty = document.querySelector('cart-drawer');
        cart_empty.classList.add('is-empty');
    }

    // Event listener to bind add to cart
    window.onload = function() {
        const element = document.querySelector('product-form');
        if(element){
        const addButtons = element.querySelectorAll('[name="add"]');
        addButtons.forEach(function(addButton) {
            addButton.addEventListener('click', addToCartClick);
        });
          }
       removeProduct();
    }

      // Start remove product functionality
      removeProduct();
  
})();



/** end free product **/


//  image slider
// window.addEventListener('load',()=>{
//      let imgDiv = document.querySelector('.product .product__media-wrapper  .product__media ');
//     let divElement = document.querySelector('.product .thumbnail-slider.swiper-vertical');
//      let  elemHeight = imgDiv.offsetHeight;
//      console.log(divElement,'divElement');
           
//      if(divElement){
//      console.log(elemHeight,'elemHeight');
//     divElement.style.height
//                 = elemHeight + "px";
//      }
        
//   })

$('.inqure').on('click', function (event) {
    event.preventDefault(); // Prevent default link behavior
    window.location.href = 'https://remsen.co/pages/contact';
});


